<ng-container *transloco="let t; prefix: 'experience'">
  <section class="experience-gallery" data-cy="experience-gallery">
    <div class="gallery">
      @if (gallery().length > 1) {
        <swiper-container init="false" essFrontSwiper #swiper [config]="config">
          <!-- hack to avoid only showing 2 slides when there is 3 -->
          @for (duplicatedSlides of [0, 1]; track duplicatedSlides) {
            @for (image of gallery(); track image) {
              <swiper-slide essFrontSwiperSlide>
                <div class="slide-wrapper">
                  <div class="gradient"></div>
                  <img
                    class="slide-image"
                    alt="{{ t('titleDetailImage', {title: title()}) }}"
                    [src]="image | resizeImg: 1260 : 850"
                    srcset="{{image | resizeImg:740:500}} 740w, {{image | resizeImg:1260:850}} 1260w"
                  />
                </div>
              </swiper-slide>
            }
          }
        </swiper-container>
        <div class="navigation" data-cy="experience-gallery-photo">
          <button
            type="button"
            [attr.aria-label]="t('previousSlide')"
            class="prev button-content"
            (click)="prevSlide()"
            data-cy="experience-gallery-photo-prev"
          >
            <i class="button-prev-arrow" [innerHTML]="prevArrowIcon"></i>
          </button>
          <button
            type="button"
            [attr.aria-label]="t('nextSlide')"
            class="next button-content"
            (click)="nextSlide()"
            data-cy="experience-gallery-photo-next"
          >
            <i class="button-next-arrow" [innerHTML]="nextArrowIcon"></i>
          </button>
        </div>
        <div class="pagination" data-cy="experience-pagination">{{ currentSlide + 1 }}/{{ gallery().length }}</div>
      } @else {
        <div class="full-image-container">
          <img alt="{{ t('titleDetailImage', {title: title()}) }}" [src]="gallery()[0]" />
        </div>
      }
    </div>
  </section>
</ng-container>
